// Swag Image Library
// This library will be populated with swag images later
// Each swag item should have an id, imageUrl, and optionally a name

const swagLibrary = [
  // Placeholder structure - will be populated later
  // Each item should follow this structure:
  // {
  //   id: 'swag-1',
  //   imageUrl: 'https://example.com/swag1.jpg',
  //   name: 'Swag Item 1' // optional
  // }
];

export default swagLibrary;

